import React from 'react'
import Icon from 'app/views/components/Icon'
import ModalListItem from './ModalListItem'
import ReactMarkdown from 'react-markdown'
import rehypeRaw from 'rehype-raw'
import { parse } from 'path-to-regexp'
import { Button } from '@hackedu/react-components'

class HintModal extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      hintContent: null
    }
    this.onAccept = this.onAccept.bind(this)
  }

  renderHintOptions() {
    let { hints, contentType } = this.props
    return (<ul className="uk-list uk-padding-small">
      {hints.map((item) => {
        let used = contentType !== 'mobile' ? (typeof (this.props.usedHints || this.props.metadata.usedHints || {})[item.id] === 'number') : false
        return (<li key={item.id}>
          <ModalListItem
            type={item.hint_type ? item.hint_type : ''}
            title={item.title}
            points={item.points}
            used={used}
            description={item.description ? item.description : ''}
            onClick={() => {
              if (item.hint_type !== 'highlight') {
                this.props.getHint(
                  item.id,
                  (hintModalData) => {
                    if (this.props.updateParentContentHints) {
                      this.props.updateParentContentHints({
                        [hint.id]: hintModalData.metadata.points,
                      })
                    }
                    this.setState({
                      hintContent: hintModalData
                    })
                  },
                  this.props.isAssessment ? this.props.assessmentUUID : null,
                )
              } else {
                let points = parseInt(item.points) || 0
                if (points != 0) {
                  this.setState({
                    hintContent: {
                      title: item.title,
                      hint_type: 'highlight',
                      hint_id: item.id
                    }
                  })
                } else {
                  this.setState({
                    hintContent: null
                  })
                  this.props.showCodeReviewModal(null)
                  this.props.onResetSandbox(() => {
                    this.props.getHint(
                      item.id,
                      (hintModalData) => {
                        if (this.props.updateParentContentHints) {
                          this.props.updateParentContentHints({
                            [hint.id]: parseInt(hintModalData.metadata.points) || 0,
                          })
                        }
                        this.setState({
                          hintModalData,
                        })
                      },
                      this.props.isAssessment ? this.props.assessmentUUID : null,
                    )
                  }, true)
                }
              }
            }}
          />
        </li>)
      })}
    </ul>
      // <li >
      // <ModalListItem 
      //    type="help-articles"
      //    title="Help Articles"
      //    description="Check out frequently asked questions for this lesson."
      //   />
      // </li>
      // <li >
      // <ModalListItem 
      //    type="contact-support"
      //    title="Contact Support"
      //    description="Still can't what you're looking for? Chat with our team to get some extra guidance."
      //   />
      // </li>
    )
  }

  onAccept() {
    this.setState({
      hintContent: null
    })
    this.props.showCodeReviewModal(null)
    this.props.onResetSandbox(() => {
      this.props.getHint(
        this.state.hintContent.hint_id,
        (hintModalData) => {
          if (this.props.updateParentContentHints) {
            this.props.updateParentContentHints({
              [hint.id]: parseInt(hintModalData.metadata.points) || 0,
            })
          }
          this.setState({
            hintModalData,
          })
        },
        this.props.isAssessment ? this.props.assessmentUUID : null,
      )
    }, true)
  }

  render() {
    return (
      <>
        <button className="uk-modal-close-default" type="button" uk-close="true" onClick={() => {
          this.setState({
            hintContent: null
          })
        }}></button>
        <div>
          {!this.state.hintContent && <>
            <div className="uk-modal-header">
              <h2 style={{ fontSize: "16px" }}>Choose a hint</h2>
            </div>
            {this.renderHintOptions()}
          </>
          }
          {this.state.hintContent &&
            <>
              <div
                className="uk-modal-header" style={{ padding: '15px 0px', cursor: 'pointer' }}
                onClick={() => {
                  this.setState({
                    hintContent: null
                  })
                }}
              >
                <div style={{ display: 'flex', alignItems: "center" }}>
                  <Icon
                    name={'arrow-left-s'}
                    className="uk-margin-small-right"
                    style={{ color: '#BDBDBD' }}

                  />
                  <label style={{ fontSize: "16px" }}>{this.state.hintContent.title}</label>
                </div>

              </div>
              <div className="uk-modal-body">
                {(this.state.hintContent.hint_type != 'highlight') && <>
                  <ReactMarkdown
                    rehypePlugins={[rehypeRaw]}
                    linkTarget="_blank"
                    children={this.state.hintContent.markdown ? this.state.hintContent.markdown : ''}
                  />
                  <Button
                    primary
                    extraClassName="uk-align-right"
                    onClick={() => {
                      this.setState({
                        hintContent: null
                      })
                    }}
                    content="Back"

                  />
                </>}

                {this.state.hintContent.hint_type == 'highlight' && <>
                  Using this hint requires us to reset any changes you have made to the app and give you a new sandbox. Are you sure you want to proceed?
                  <Button
                    extraClassName="uk-align-right"
                    primary
                    onClick={this.onAccept}
                    content="Accept"
                  />
                </>}
              </div>
            </>}
        </div>
      </>
    )
  }
}
export default HintModal
